// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Qbduh","header":"MergedInvoice_header__2H4fH"};